import { createBrowserRouter, Navigate } from 'react-router-dom';
import Routes from './Routes.ts';
import LoginPage from '@/pages/LoginPage.tsx';
import SandboxPage from '@/pages/SandboxPage.tsx';
import { transformRouterConfig } from '@/router/transformRouter.tsx';
import RegisterPage from '@/pages/RegisterPage.tsx';
import Default from '@/layouts/Default/Default.tsx';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage.tsx';
import ResetPasswordPage from '@/pages/ResetPasswordPage.tsx';
import HomePage from '@/pages/HomePage.tsx';
import SimpleCenter from '@/layouts/SimpleCenter/SimpleCenter.tsx';
import ConfirmEmailPage from '@/pages/ConfirmEmailPage.tsx';
import PaymentSelectPage from '@/pages/PaymentSelectPage.tsx';
import DataTablePage from '@/pages/DataTablePage.tsx';
import InputsPage from '@/pages/InputsPage.tsx';
import { LayoutInternal } from '$/views/emails/layout.tsx';
import BrandedSimple from '@/layouts/BrandedSimple/BrandedSimple.tsx';
import PasswordChangedConfirmationPage from '@/pages/PasswordChangedConfirmationPage.tsx';
import EmailChangedConfirmationPage from '@/pages/EmailChangedConfirmationPage.tsx';
import ResidentOnboarding from '@/pages/ResidentOnboarding.tsx';
import VendorOnboarding from '@/pages/VendorOnboarding.tsx';
import AdminBuildings from '@/pages/AdminBuildings.tsx';

const router = createBrowserRouter(
  transformRouterConfig([
    {
      path: '/',
      element: <Default.Layout />,
      middleware: ['loggedIn'],
      children: [
        {
          path: Routes.DASHBOARD,
          element: <HomePage />,
        },
        {
          path: Routes.SANDBOX,
          element: <SandboxPage />,
        },
        {
          path: Routes.DATA_TABLE,
          element: <DataTablePage />,
        },
        {
          path: Routes.INPUTS,
          element: <InputsPage />,
        },
      ],
    },
    {
      path: '/',
      element: <SimpleCenter />,
      middleware: ['loggedIn'],
      children: [
        {
          path: Routes.ADMIN_BUILDINGS,
          element: <AdminBuildings />,
        },
      ],
    },
    {
      path: '/',
      element: <SimpleCenter />,
      middleware: ['loggedIn'],
      children: [
        {
          path: Routes.RESIDENT_ONBOARDING,
          element: <ResidentOnboarding />,
        },
      ],
    },
    {
      path: '/',
      element: <SimpleCenter />,
      middleware: ['loggedIn'],
      children: [
        {
          path: Routes.VENDOR_ONBOARDING,
          element: <VendorOnboarding />,
        },
      ],
    },
    {
      path: '/',
      element: <SimpleCenter />,
      children: [
        {
          path: Routes.CONFIRM_EMAIL,
          element: <ConfirmEmailPage />,
        },
      ],
    },
    {
      path: '/',
      element: <SimpleCenter />,
      middleware: ['notLoggedIn'],
      children: [
        {
          path: Routes.FORGOT_PASSWORD,
          element: <ForgotPasswordPage />,
        },
        {
          path: Routes.LOGIN,
          element: <LoginPage />,
        },
        {
          path: Routes.REGISTER,
          element: <RegisterPage />,
        },
        {
          path: Routes.CONFIRM_EMAIL,
          element: <ConfirmEmailPage />,
        },
      ],
    },
    // SimpleCenter layout
    {
      path: '/',
      element: <SimpleCenter />,
      children: [
        {
          path: Routes.RESET_PASSWORD,
          element: <ResetPasswordPage />,
        },
      ],
    },
    {
      path: '/',
      element: <BrandedSimple />,
      children: [
        {
          path: Routes.PASSWORD_CHANGED_CONFIRMATION,
          element: <PasswordChangedConfirmationPage />,
        },
        {
          path: Routes.EMAIL_CHANGED_CONFIRMATION,
          element: <EmailChangedConfirmationPage />,
        },
      ],
    },
    // SimpleCenter logged in
    {
      path: '/',
      element: <SimpleCenter />,
      middleware: ['loggedIn'],
      children: [
        {
          path: Routes.PAYMENT_SELECT,
          element: <PaymentSelectPage />,
        },
      ],
    },
    {
      path: Routes.EMAIL_TEMPLATE,
      element: (
        <LayoutInternal
          appUrl={import.meta.env.VITE_APP_URL}
          appName={'app-name'}
          logo={`${import.meta.env.VITE_APP_URL}/assets/logo.png`}
        >
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab animi atque possimus, quaerat quasi tempore
          totam! Architecto assumenda cumque deleniti dolor expedita facilis illo minima nihil quidem soluta? Hic,
          laboriosam!
        </LayoutInternal>
      ),
    },
    {
      path: '*',
      element: <Navigate to={Routes.DASHBOARD} />,
    },
  ])
);

export default router;
